import ResponsiveHelper from "../utils/ResponsiveHelper";
import Swiper from "swiper/bundle";

export default class Homepage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
    this.initHeroSlider();
    this.updateSlider();
    // this.initProductsSilder();
    // this.initWorkshopSlider();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
      this.updateSlider();
    });
  }

  initHeroSlider() {
    // this.updateSlider();

    const hmSlider = new Swiper(".hero-banner--slider", {
      // Optional parameters
      loop: true,
      speed: 650,

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
  updateSlider() {
    setTimeout(() => {
      let slider = this.dom.querySelector(".hero-banner--slider");
      const style = slider.style;
      // var height = slider.clientHeight;
      // console.log(height);
      // style.setProperty("--svh", `${slider.clientHeight}px`);
      // document.body.style.setProperty("--svh", `${slider.clientHeight}px`);
      document.body.style.setProperty("--svh", `${slider.scrollHeight}px`);
    }, 100);

    // console.log(style);
  }

  // initProductsSilder() {
  //   let hmPrSlider = this.dom.querySelector(".hm-product-slider");
  //   const hmPswiper = new Swiper(".hm-product-slider", {
  //     // Optional parameters
  //     // direction: "vertical",
  //     slidesPerView: 1.5,
  //     // slidesPerGroup: 1,
  //     spaceBetween: 20,
  //     // grabCursor: true,
  //     watchOverflow: true,
  //     slidesOffsetAfter: 10,
  //     slidesOffsetBefore: 10,

  //     breakpoints: {
  //       768: {
  //         slidesPerView: 2.5,
  //         spaceBetween: 25,
  //         slidesOffsetAfter: 10,
  //         slidesOffsetBefore: 10,
  //       },

  //       992: {
  //         slidesPerView: 3.5,
  //         spaceBetween: 25,
  //         slidesOffsetAfter: 25,
  //         slidesOffsetBefore: 25,
  //       },
  //     },

  //     // If we need pagination
  //     pagination: {
  //       el: ".swiper-pagination",
  //     },

  //     // Navigation arrows
  //     navigation: {
  //       nextEl: ".hm-product-slider .swiper-button-next",
  //       prevEl: ".hm-product-slider .swiper-button-prev",
  //     },
  //   });
  // }

  resize() {
    // console.log("resize from Homepage.js");
    this.updateSlider();
  }
}
